import { api } from "./client";
import type { ListingAgentPhoneType } from "./buyers";

/**
 * PASTE TO FILL (D1–D6) — wire mirror of `ListingAgentPasteExtractRequest` /
 * `ListingAgentPasteExtractionDto` / `ListingAgentPasteCandidateDto`.
 *
 * <p>Exactly ONE of `text` and `imageBase64` (raw base64, no `data:` prefix).
 * The server refuses both, neither, text over 20,000 characters and an image
 * over 5 MB or not a PNG / JPEG / WebP with a 400; an unusable reply or a spent
 * AI limit is a 422; the staff AI rate limit answers 429. A paste that names
 * nobody is a 200 with `people: []`.</p>
 *
 * <p>Shared by the New listing agent form, the Edit listing agent modal and the
 * agent research workspace.</p>
 */
export interface ListingAgentPasteExtractPayload {
  text?: string;
  imageBase64?: string;
  imageMediaType?: string;
}

/** One listing broker or agent read from a paste. The first nine fields map to
 *  the New listing agent form; the last four have no form field. */
export interface ListingAgentPasteCandidateDto {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  phoneType: ListingAgentPhoneType;
  firmName?: string | null;
  title?: string | null;
  city?: string | null;
  state?: string | null;
  firmGeneralEmail?: string | null;
  firmMainPhone?: string | null;
  contactFormUrl?: string | null;
  profileUrl?: string | null;
}

export interface ListingAgentPasteExtractionDto {
  people: ListingAgentPasteCandidateDto[];
  /** The model's one line for facts no field holds. Offered, never written. */
  notesLine?: string | null;
  /** No verbatim check was possible: every value is "read from image — check it". */
  fromImage: boolean;
  /** Values left out because a text paste did not contain them, or they were
   *  not a valid email, phone, state or web address. */
  droppedValueCount: number;
  /** More than ten people were named; only the first ten are here. */
  peopleTruncated: boolean;
  aiModel?: string | null;
}

export const listingAgentPasteApi = {
  extract: (body: ListingAgentPasteExtractPayload) =>
    api.post<ListingAgentPasteExtractionDto>("/listings/agents/paste-extract", body),
};
